import { ChangeEvent, MouseEvent as ReactMouseEvent, useEffect, useState } from 'react';

import Search from '~components/Icon/Search';
import useGetCompanyAutoComplete from '~hooks/query/company/useCompanyAutoComplete';
import useDocumentClick from '~hooks/useDocumentClick';
import { ICompany } from '~types/company';

import * as S from './style';

interface Props {
  defaultValue?: string;
  onClick: (company: ICompany) => void;
}

export default function SearchCompany({ defaultValue = '', onClick }: Props) {
  const [dirty, setDirty] = useState<boolean>();
  const [disabledFetch, setDisabledFetch] = useState<boolean>();
  const [queryCompany, setQueryCompany] = useState<string>(defaultValue);
  const [suggestionModalOpen, setSuggestionModalOpen] = useState<boolean>();
  const { data } = useGetCompanyAutoComplete(queryCompany);

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    setQueryCompany(e.target.value);

    if (!dirty) {
      setDirty(true);
    }

    if (disabledFetch) {
      setDisabledFetch(false);
    }
  };

  const handleClick = (e: ReactMouseEvent<HTMLAnchorElement>, company: ICompany) => {
    e.stopPropagation();
    setQueryCompany(company.name);
    setSuggestionModalOpen(false);
    setDisabledFetch(true);

    if (onClick) {
      onClick(company);
    }
  };

  useDocumentClick(() => setSuggestionModalOpen(false));

  useEffect(() => {
    if (data && !disabledFetch) {
      setSuggestionModalOpen(true);
    } else {
      setSuggestionModalOpen(false);
    }
  }, [data, disabledFetch]);

  return (
    <S.Wrapper>
      <S.SearchIconWrapper>
        <Search width={18} color='#d6d6d6' />
      </S.SearchIconWrapper>
      <S.InputSearchCompany
        placeholder='회사를 검색해주세요.'
        value={queryCompany}
        onChange={handleChange}
      />
      {suggestionModalOpen && dirty && queryCompany !== '' && (
        <S.SuggestionCompany>
          <S.SuggestionTitle>검색결과</S.SuggestionTitle>
          {data?.numFound === 0 ? (
            <S.NoData>검색결과가 없습니다.</S.NoData>
          ) : (
            <>
              {data?.docs.map((company) => (
                <S.SuggestionCompanyItem
                  key={`jobdom-write-${company.PK_NM_HASH}`}
                  onClick={(e) => handleClick(e, company)}>
                  <strong>{company.name}</strong> / {company.location}
                </S.SuggestionCompanyItem>
              ))}
            </>
          )}
        </S.SuggestionCompany>
      )}
    </S.Wrapper>
  );
}
